import { LOAD_FEED, PAGE_COMPONENTS, SWIMLANE_ITEMS, SET_TRENDING_FEED } from "./actions";

const initialState = {
  content: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_FEED:
      return { ...state, content: action.content };
    case PAGE_COMPONENTS:
      return { ...state, pageComponents: action.components };
    case SWIMLANE_ITEMS:
      return { ...state, swimlaneItems: action.items };
    case SET_TRENDING_FEED:
      return { ...state, trendingFeed: action.trendingFeed };
    default:
      return state;
  }
};
